import React, { useCallback } from "react";

import { ApolloError } from "@apollo/client";
import { STATUS_COLOR } from "@hl/base-components/lib/theme/colors";
import {
  getOpenSeaCollectionSlugFromUrl,
  validateOpenSeaUrl,
} from "@hl/shared-features/lib/utils/opensea";
import { Loader, Text, TextInput } from "@mantine/core";
import { ethers } from "ethers";

import { NetworkType } from "apollo/graphql.generated";
import {
  CollectionDetailsQuery,
  ContractDetailsQuery,
} from "~/features/gates/queries/gates.graphql.generated";

type InputSectionProps = {
  openSeaCollection?: CollectionDetailsQuery;
  openSeaErrors?: ApolloError;
  contractCollection?: ContractDetailsQuery;
  onEnterUrl: (url: string) => void;
  onEnterContract: React.Dispatch<React.SetStateAction<string | undefined>>;
  loading: boolean;
  setNetwork: React.Dispatch<React.SetStateAction<NetworkType | undefined>>;
  placeholderText: string;
};

export const CONTRACT_NOT_FOUND_MSG =
  "Contract not found. Confirm the contract address and blockchain are correct. If no tokens have been minted on this contract, it will not be visible until one is. Consider minting a test token to fix this issue.";

export const CHAIN_NOT_SUPPORTED_MSG =
  "This collection uses an unsupported chain.";

export const CollectionContractInputSection = ({
  openSeaCollection,
  openSeaErrors,
  contractCollection,
  onEnterUrl,
  onEnterContract,
  loading,
  setNetwork,
  placeholderText,
}: InputSectionProps) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const val = e.target.value;
      const baseUrl = val.trim();
      const isOSUrl = validateOpenSeaUrl(baseUrl);
      if (ethers.utils.isAddress(val)) {
        onEnterContract(val);
      } else if (isOSUrl) {
        console.log("asd", getOpenSeaCollectionSlugFromUrl(baseUrl));
        onEnterUrl(getOpenSeaCollectionSlugFromUrl(baseUrl));
      } else {
        onEnterContract(undefined);
      }

      // handle error case, reset network selection
      if (
        !openSeaCollection ||
        (openSeaCollection && !openSeaCollection.collectionDetails.standard)
      ) {
        setNetwork(undefined);
      }
      if (
        !contractCollection ||
        (contractCollection && !contractCollection.contractDetails.standard)
      ) {
        setNetwork(undefined);
      }
    },
    [onEnterUrl, onEnterContract]
  );

  if (openSeaCollection && openSeaCollection.collectionDetails.standard) {
    return <></>;
  }
  if (contractCollection && contractCollection.contractDetails.standard) {
    return <></>;
  }

  return (
    <>
      <TextInput
        size="md"
        placeholder={placeholderText}
        label={"Specify a " + placeholderText}
        onChange={handleChange}
        rightSection={loading && <Loader size="sm" />}
      />
      <Text size="xs" mt={5} color={STATUS_COLOR.ERROR}>
        {openSeaCollection && "Error finding Collection"}
        {contractCollection && CONTRACT_NOT_FOUND_MSG}
        {openSeaErrors &&
          openSeaErrors?.message
            .toLowerCase()
            .startsWith("unsupported chain") &&
          CHAIN_NOT_SUPPORTED_MSG}
      </Text>
    </>
  );
};
